export interface PaginatedResponse<T> {
  data: T[];
  meta: Meta;
}

export interface Meta {
  pageNumber: number;
  pageSize: number;
  totalRows: number;
  totalPages: number;
}

export interface PaginationType {
  totalRows: number;
  currentPage: number;
  pageSize: number;
}

export const initialPagination: PaginationType = {
  totalRows: 0,
  currentPage: 1,
  pageSize: 10,
};
